<template>
  <TemplateSingleLayout :loaded="!!template && !!categories" :tabs="tabs">
    <!-- title -->
    <template #template-heading>
      <TemplateEditPageHeader :template="template" />
    </template>
    <!-- single tabs -->
    <!-- info -->
    <template #configuracion>
      <TemplateEditPageSettings
        :template="template"
        :categories="categories"
        @updated="updateTemplateDraft"
        @updated-editors="updateTemplateMain"
      />
    </template>
    <!-- content -->
    <template #contenido>
      <TemplateEditPageContent :template="template" @updated="updateTemplateDraft" />
    </template>
  </TemplateSingleLayout>
</template>

<script>
// Utilities
import { apiErrorHandling } from 'Modules/Templates/utils'
// Components
import TemplateSingleLayout from 'Layouts/TemplateSingleLayout'
import TemplateEditPageHeader from './components/TemplateEditPageHeader'
import TemplateEditPageContent from './components/TemplateEditPageContent'
import TemplateEditPageSettings from './components/TemplateEditPageSettings'

export default {
  name: 'TemplatesSingleEditPage',

  components: {
    TemplateSingleLayout,
    TemplateEditPageHeader,
    TemplateEditPageContent,
    TemplateEditPageSettings,
  },

  props: {
    temp_id: {
      type: [String, Number],
      required: true,
    },
    temp_title: {
      type: String,
    },
  },

  data() {
    return {
      categories: null,
      syncTimeout: null,
      tabs: [
        { name: 'Configuración', slug: 'configuracion' },
        { name: 'Contenido', slug: 'contenido' },
      ],
    }
  },

  methods: {
    async updateTemplateMain(updatedValue) {
      const today = new Date()
      await this.$store.dispatch('templates/updateTemplate', updatedValue)
      // updating modified draft's date
      // Updating template draft
      this.updateTemplateDraft({ modified: today.toISOString() })
    },

    async updateTemplateDraft(newValues) {
      await this.$store.dispatch('templates/updateTemplateDraft', newValues)
    },
  },

  computed: {
    template() {
      return this.$store.state.templates.templateDraft
    },
  },

  async mounted() {
    try {
      // getting categories
      await this.$store.dispatch('categories/load')
      this.categories = this.$store.state.categories.categories
      // getting diy users
      await this.$store.dispatch('user/loadDIYUsers')
    } catch (error) {
      apiErrorHandling(error)
    }
  },
}
</script>

<style scoped>
.template-edit >>> .diy-tooltip {
  position: relative;
  top: -5px;
  left: 5px;
}
</style>
